import { AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getHeaderItemByIdBuilder(apiClient: AxiosInstance) {
  return async function getHeaderItemById(
    id: number,
  ): Promise<IContent.HeaderItemsResponse | null> {
    try {
      const response = await apiClient.get(`/v2/headers/${id}/`);
      return response.data;
    } catch (error) {
      return null;
    }
  };
}
